/** Which unpublished draft the editor should open. Ticket 18. */
export type DraftChoice = {
  id: number
  published?: boolean
  updated_at?: string | null
}

export function autoDraftId(
  drafts: DraftChoice[],
  currentId: number | null,
  hadDraftId: boolean,
): number | null {
  if (currentId != null) return currentId
  if (hadDraftId) return null
  const active = [...drafts]
    .filter(d => !d.published)
    .sort((a, b) => (b.updated_at ?? '').localeCompare(a.updated_at ?? ''))[0]
  return active?.id ?? null
}

/** Autosave may POST a new draft only on first visit with no id. After publish, id is null on purpose. */
export function shouldAutosaveCreateDraft(
  currentId: number | null,
  hadDraftId: boolean,
): boolean {
  return currentId == null && !hadDraftId
}
